import React from 'react';

export const Feedback = (props) => (
  <svg
    fill="none"
    height="22"
    id="feedback"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.9025 2.75C16.8556 2.75 20.1667 5.04167 20.1667 9.8126C20.1667 13.75 16.8551 15.9585 13.9021 15.9585H7.18064L4.41294 19.0637C3.22781 19.6432 1.83341 18.8004 1.83341 17.5047V9.8126L1.85735 9.625C1.85735 5.95834 5.02366 2.75 7.79175 2.75L13.9025 2.75ZM3.36119 9.8126C3.36119 7.33334 5.68224 4.24408 7.79175 4.24408L13.9025 4.24408C16.012 4.24408 18.639 5.83129 18.639 9.8126C18.639 13.2917 16.0117 14.4645 13.9021 14.4645H7.00031H6.81341L6.65869 14.5433L3.72969 17.7274C3.56039 17.8102 3.36119 17.5047 3.36119 17.5047C3.36119 17.5047 3.36119 12.2919 3.36119 9.8126Z"
      fill="black"
      fillRule="evenodd"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="8.25"
      x2="12.75"
      y1="10.75"
      y2="10.75"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="8.25"
      x2="14.75"
      y1="7.75"
      y2="7.75"
    />
  </svg>
);
